import {
  Home,
  Palmtree,
  Building,
  Building2,
  TentTree,
  Caravan,
  Sailboat,
} from "lucide-react";

/**
 * Shared registry of household icon options.
 *
 * Each entry: { slug, label, Icon } where `slug` is the value persisted on
 * the household document (matches `HOUSEHOLD_ICONS` in backend/models.py),
 * `label` is the user-facing name shown in the picker, and `Icon` is the
 * lucide-react component used everywhere we render the household.
 *
 * Adding a new option here is a two-line change: append below and add the
 * matching slug to `HOUSEHOLD_ICONS` in models.py. Everything else (picker,
 * switcher, transition, dashboard chip) reads from this registry so the
 * UI stays in sync automatically.
 */
export const HOUSEHOLD_ICON_OPTIONS = [
  { slug: "home", label: "House", Icon: Home },
  { slug: "palm", label: "Beach", Icon: Palmtree },
  { slug: "office", label: "Office", Icon: Building },
  { slug: "apartment", label: "Apartment", Icon: Building2 },
  { slug: "cabin", label: "Cabin", Icon: TentTree },
  { slug: "trailer", label: "Mobile", Icon: Caravan },
  { slug: "boat", label: "Boat", Icon: Sailboat },
];

const BY_SLUG = Object.fromEntries(
  HOUSEHOLD_ICON_OPTIONS.map((o) => [o.slug, o]),
);

/** Resolve a stored slug to a lucide icon component. Falls back to Home. */
export const getHouseholdIcon = (slug) => {
  const opt = BY_SLUG[slug];
  return opt ? opt.Icon : Home;
};

/** Resolve a slug to its human label. Falls back to "House". */
export const getHouseholdIconLabel = (slug) => {
  const opt = BY_SLUG[slug];
  return opt ? opt.label : "House";
};
